import { useEffect, useState } from 'react';

export type TDrawer =
	| 'add-new-batch-process'
	| 'view-batch-process-details'
	| 'view-copilot-video-details'
	| 'view-content-monitor-video-details'
	| 'view-product-subscription'
	| 'subscription-configuration'
	| 'add-new-monitor'
	| 'edit-monitor'
	| 'add-new-creator'
	| 'add-new-category'
	| 'qa-history'
	| 'add-new-qa-collection'
	| 'edit-qa-collection'
	| 'add-new-copilot-batch'
	| 'view-batch-process-report';

export type TModals = 'unsubscribe';

export interface IDrawerProps {
	isOpen: boolean;
	type: TDrawer | null;
	data: any;
}

export interface IModalProps {
	isOpen: boolean;
	type: TModals | null;
	data: any;
}

const useDrawer = () => {
	const [drawer, setDrawer] = useState<IDrawerProps>({
		isOpen: false,
		type: null,
		data: null,
	});

	const openDrawer = (type: TDrawer, data?: any) => {
		setDrawer({
			isOpen: true,
			type,
			data,
		});
	};

	const closeDrawer = () => {
		setDrawer({
			isOpen: false,
			type: null,
			data: null,
		});
	};

	return { drawer, isOpen: drawer.isOpen, openDrawer, closeDrawer };
};

export const useModal = () => {
	const [modal, setModal] = useState<IModalProps>({
		isOpen: false,
		type: null,
		data: null,
	});

	const openModal = (type: TModals, data?: any) => {
		setModal({
			isOpen: true,
			type,
			data,
		});
	};

	const closeModal = () => {
		setModal({
			isOpen: false,
			type: null,
			data: null,
		});
	};

	return { modal, isOpen: modal.isOpen, openModal, closeModal };
};

export default useDrawer;
